import classNames from 'classnames';

import CheckIcon from '@heroicons/react/20/solid/CheckIcon';
import { ThemeText, ThemePrimary } from '../../context/theme/ThemeConstantsUpdated';

const { mainText } = ThemeText;
const { primaryText } = ThemePrimary;

export const FeatureCategory = (props: Props) => {
  const { label, features, isActive } = props;

  return (
    <div className="font-mono">
      {label && <h4 className={classNames(isActive ? 'text-white' : mainText, 'mb-4 font-semibold')}>{label}</h4>}

      <ul role="list" className="space-y-3 text-base leading-6">
        {features.map((f) => (
          <li className="flex gap-x-3">
            <CheckIcon className={classNames(isActive ? 'text-white' : primaryText, 'h-6 w-5 flex-none')} />
            <span className={classNames(isActive ? 'text-white' : mainText, 'text-md')}>{f}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

type Props = {
  label?: string;
  features: Array<string>;
  isActive?: boolean;
};
